import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Tags, XCircle } from "lucide-react";
import { useMenuContext } from "../../context/useMenuContext";
import { usePermissions } from "../../usePermissions";
import { useUser } from "../../../../../../utils/hooks/user";

export const useOpenShiftMenu = ({ openClaimShiftDrawer }: any) => {
    const { t } = useTranslation();
    const user = useUser();
    const { canApproveRequest, canDenyRequest } = usePermissions();
    const { selected, closeMenu } = useMenuContext();

    return useMemo(() => {
        const isApprover = (selected?.requiredToBeApprovedBy || []).includes(user?.id) || selected?.requestType === "open-shift" || selected?.requestType === "call-off";
        const isPending = selected?.status === "pending" || selected?.status === "pending-canceled";

        const menuItems = [
            {
                icon: Tags,
                label: t("claim"),
                onChange: () => {
                    openClaimShiftDrawer({ ...selected, actionType: "claim", close: closeMenu });
                    closeMenu();
                },
                hidden: !((isApprover || canApproveRequest) && isPending),
                disabled: false
            },
            {
                icon: XCircle,
                label: t("deny"),
                onChange: () => {
                    openClaimShiftDrawer({ ...selected, actionType: "deny", close: closeMenu });
                    closeMenu();
                },
                hidden: !((isApprover || canDenyRequest) && isPending),
                disabled: false
            }
        ];

        return menuItems.filter((item: any) => !item.hidden);
    }, [canDenyRequest, canApproveRequest, user?.id, openClaimShiftDrawer, selected, closeMenu, t]);
};
